import { type ChipColor } from "@pmag/ui-components";
import { SPFAvailabilityStatus } from "@src/utils/events";

export const getAvailabilityStatusChipColor = (availabilityStatus: string): ChipColor => {
    if (availabilityStatus === SPFAvailabilityStatus.Available) return "green";
    if (availabilityStatus === SPFAvailabilityStatus.NotAvailable) return "red";
    if (availabilityStatus === SPFAvailabilityStatus.ManufacturerAvailable) return "yellow";

    return "grey";
};
